
import React from 'react';
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { DollarSign, ArrowRight } from "lucide-react";

interface DreamRateStepProps {
  formData: {
    desiredHourlyRate: string;
  };
  onInputChange: (field: string, value: string) => void;
  onNext: () => void;
}

const DreamRateStep: React.FC<DreamRateStepProps> = ({
  formData,
  onInputChange,
  onNext,
}) => {
  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <h3 className="text-2xl font-bold">Your Dream Rate</h3>
        <p className="text-muted-foreground">
          What hourly rate are you aiming for?
        </p>
      </div>

      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="desiredHourlyRate">Desired Hourly Rate</Label>
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2">
              <DollarSign className="h-4 w-4 text-muted-foreground" />
            </span>
            <Input
              id="desiredHourlyRate"
              type="number"
              placeholder="Enter your target rate"
              value={formData.desiredHourlyRate}
              onChange={(e) => onInputChange('desiredHourlyRate', e.target.value)}
              className="pl-10"
            />
          </div>
        </div>

        <Button 
          onClick={onNext}
          className="w-full"
          disabled={!formData.desiredHourlyRate}
        >
          Next Step
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default DreamRateStep;
